const formatObj = new Intl.NumberFormat('en-US');
const DateFormatter = new Intl.DateTimeFormat("en-GB", {
  hour: 'numeric', minute: 'numeric',
  year: 'numeric', month: 'numeric', day: 'numeric',
});
export const capitalize = (str) => {
    if(typeof str !== "string") return str;
    return str.charAt(0).toUpperCase() + str.substring(1);
}

export function pad(number, length){
  var str = "" + number
  while (str.length < length) {
      str = '0'+str
  }
  return str
}

function fallbackCopyTextToClipboard(text, callback) {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    
    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
  
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
  
    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
      callback?.(null, msg);
    } catch (err) {
      callback?.(err);
    }
  
    document.body.removeChild(textArea);
  }
export function copyTextToClipboard(text, callback=(err,msg) => {}) {
    if (!navigator.clipboard) {
      fallbackCopyTextToClipboard(text, callback);
      return;
    }
    navigator.clipboard.writeText(text).then(function() {
        callback?.(null, 'successful');
    }, function(err) {
        callback?.(err);
    });
  }

export const encodeStr = (str) => {
  return btoa(str);
}
export const decodeStr = (encoded) => {
  return atob(encoded)
}

export const convertToCurrency = (str) => {
  if(!parseFloat(str)) return str;
  return formatObj.format(str)
}

export const convertDate = (time) => {
  if(!time || typeof time != "string") return time;
  const formatted = time.split(" ").join("T");
  return  DateFormatter.format(new Date(formatted)).replace(",","");
}